import { ReconciliationServiceSetting } from '@/features/reconciliation_service_setting';

const ReconciliationServiceSettingPage = () => {
  return <ReconciliationServiceSetting />;
};

export default ReconciliationServiceSettingPage;
